const CategoryDictionaryHelper = {
  categoryName: category => {
    switch (category) {
      case 'questions_prequalify':
        return 'Financial Needs'
      case 'questions_prequalify_paycheck_protection':
        return 'Paycheck Protection'
      case 'questions_basic_info':
        return 'Basic Info'
      case 'questions_experience':
        return 'Experience'
      case 'questions_legal':
        return 'Legal Questions'
      case 'questions_closing':
        return 'SBA Required Questions'
      case 'questions_story':
        return 'Story'
      case 'questions_payroll_info':
        return 'Payroll Information'
      case 'questions_payroll_funds':
        return 'Purpose of the loan'
      case 'questions_payroll_revenue':
        return 'Revenue'
      default:
        return ''
    }
  }
}

export default CategoryDictionaryHelper
